/*
 This file is part of GNU Taler
 (C) 2019-2026 Taler Systems S.A.

 GNU Taler is free software; you can redistribute it and/or modify it under the
 terms of the GNU General Public License as published by the Free Software
 Foundation; either version 3, or (at your option) any later version.

 GNU Taler is distributed in the hope that it will be useful, but WITHOUT ANY
 WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 A PARTICULAR PURPOSE.  See the GNU General Public License for more details.

 You should have received a copy of the GNU General Public License along with
 GNU Taler; see the file COPYING.  If not, see <http://www.gnu.org/licenses/>

 SPDX-License-Identifier: AGPL3.0-or-later
*/

/**
 * Imports.
 */
import { HttpRawLib } from "./http-common.js";

/**
 * Stub for platforms that have no HTTP implementation.
 */
export const rawLib: HttpRawLib = {
  fetch() {
    throw new Error("Method not implemented. HttpRawLib.fetch");
  },
};
